/* ====================================================================
   FBT Popup v2 — Wird oft zusammen gekauft
   ====================================================================
   Trigger:
     A) cart:item-added  → PDP + Form-Submit-Pfad (normaler Add-to-Cart)
     B) [data-quick-shop-trigger="quick-add"] click → Grid-Quick-Add-Button
   Fixes v2:
     - Remove-Button erst nach Add sichtbar (fix #1)
     - Remove via /cart/change.js mit line_item key aus Response (fix #2)
     - Quick-View IM selben Modal, zurücknavigierbar (fix #3)
     - Grid-Quick-Add-Button triggert Popup über click-Intercept (fix #4)
   ==================================================================== */

(function () {
  'use strict';

  /* ── Konfiguration ──────────────────────────────────────────────── */
  var SECTION_ID            = 'fbt-recommendations';
  var POPUP_ID              = 'fbt-popup';
  var QUICK_CART_SELECTOR   = '.quick-cart';
  var QUICK_CART_ACTIVE     = 'active';
  var QUICK_ADD_TRIGGER_SEL = '[data-quick-shop-trigger="quick-add"]';

  /* ── State ──────────────────────────────────────────────────────── */
  var popupOpen       = false;
  var suppressDrawer  = false;
  var inQuickView     = false;

  /* Für fix #4: pending Quick-Add-Produkt-ID tracken */
  var pendingQuickAddProductId = null;
  var pendingQuickAddTimer     = null;
  var currentQvProductId       = null;

  /* ── DOM-Referenzen ─────────────────────────────────────────────── */
  var popup, addedProductEl, upsellSectionEl, upsellItemsEl, quickViewPanelEl;

  /* ── Init ───────────────────────────────────────────────────────── */
  function init() {
    popup = document.getElementById(POPUP_ID);
    if (!popup) return;

    addedProductEl   = document.getElementById('fbt-added-product');
    upsellSectionEl  = document.getElementById('fbt-upsell-section');
    upsellItemsEl    = document.getElementById('fbt-upsell-items');
    quickViewPanelEl = document.getElementById('fbt-quickview-panel');

    bindPopupEvents();
    setupDrawerObserver();

    /* A) normaler PDP-Add-Button */
    document.addEventListener('cart:item-added', handleItemAdded);

    /* B) Grid-Quick-Add-Button (fix #4) */
    document.addEventListener('click', handleQuickAddClick, true);

    /* cart:updated abhören um Quick-Add-Ergebnis abzufangen (fix #4) */
    document.addEventListener('cart:updated', handleCartUpdatedForQuickAdd);
  }

  /* ════════════════════════════════════════════════════════════════
     Fix #4 — Grid Quick-Add Intercept
     Das hoverless-Quick-Add-Icon nutzt po.addItemById() intern,
     das kein cart:item-added fired. Wir tracken den Klick, merken
     uns die Produkt-ID (= Variant-ID im data-product-id-Attribut),
     und triggern bei cart:updated unseren FBT-Flow.
     ════════════════════════════════════════════════════════════════ */
  function handleQuickAddClick(e) {
    var btn = e.target.closest(QUICK_ADD_TRIGGER_SEL);
    if (!btn) return;

    var productId = btn.dataset.productId;
    if (!productId) return;

    /* Variant-ID ist in data-product-id; wir müssen die Produkt-ID für
       die Recommendations-API holen. Auf dem Button liegt meist die
       Variant-ID — wir fetchen die Produkt-ID aus dem nächsten
       Produkt-Item-Container oder aus data-product-id wenn das Theme
       es so benennt. */
    var productItem = btn.closest('[data-product-id]');
    var recProductId = (productItem && productItem.dataset.productId) || productId;

    /* Falls der Container ein data-variant-id hat, ist productId die Produkt-ID */
    /* Direkt: data-product-id auf dem Button = Variant-ID laut Theme-Code.
       Wir fetchen die echte Produkt-ID via /products/<handle>.js oder wir
       nehmen die variant_id und nutzen /cart/add-Response.
       Einfachste Lösung: pendingQuickAddProductId merken + nach cart:updated
       Recommendations für diese ID fetchen. Die Recommendations-API nimmt
       product_id — wir müssen die aus der Variante auflösen. */

    /* Pending setzen, 3s Timeout */
    pendingQuickAddProductId = productId; /* variant_id — wird in cart:updated aufgelöst */
    clearTimeout(pendingQuickAddTimer);
    pendingQuickAddTimer = setTimeout(function () {
      pendingQuickAddProductId = null;
    }, 3000);
  }

  function handleCartUpdatedForQuickAdd(e) {
    if (!pendingQuickAddProductId) return;
    var variantId = pendingQuickAddProductId;
    pendingQuickAddProductId = null;
    clearTimeout(pendingQuickAddTimer);

    /* cart:updated detail enthält cart-Objekt. Die Produkt-ID des
       zuletzt hinzugefügten Items können wir aus dem Cart-Item holen,
       das diese Variant-ID hat. */
    var cart = e.detail && e.detail.cart;
    var productId = resolveProductIdFromCart(cart, variantId);

    if (!productId) {
      /* Fallback: /cart.js fetchen */
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (freshCart) {
          var pid = resolveProductIdFromCart(freshCart, variantId);
          if (pid) triggerFbtForQuickAdd(pid, variantId, freshCart);
        })
        .catch(function () {});
      return;
    }

    triggerFbtForQuickAdd(productId, variantId, cart);
  }

  function resolveProductIdFromCart(cart, variantId) {
    if (!cart || !cart.items) return null;
    var vid = String(variantId);
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (String(item.variant_id) === vid || String(item.id) === vid) {
        return item.product_id;
      }
    }
    return null;
  }

  function triggerFbtForQuickAdd(productId, variantId, cart) {
    /* Baue synthetisches product-Objekt (wie cart:item-added liefern würde) */
    var cartItem = null;
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].product_id) === String(productId)) {
          cartItem = cart.items[i];
          break;
        }
      }
    }

    var syntheticProduct = {
      product_id: productId,
      id: productId,
      title: cartItem ? cartItem.product_title : '',
      featured_image: cartItem ? { url: cartItem.image } : null,
      price: cartItem ? cartItem.price : 0
    };

    fetchRecommendations(productId, function (html, hasItems) {
      if (!hasItems) {
        suppressDrawer = false;
        return;
      }
      suppressDrawer = true;
      renderAddedProduct(syntheticProduct);
      renderUpsellItems(html);
      openPopup();
      setTimeout(function () { suppressDrawer = false; }, 1500);
    });
  }

  /* ════════════════════════════════════════════════════════════════
     Normaler cart:item-added Handler (PDP + Form-Submit)
     ════════════════════════════════════════════════════════════════ */
  function handleItemAdded(evt) {
    var product = evt.detail && evt.detail.product;
    var productId = product && (product.product_id || product.id);
    if (!productId) return;

    /* Wenn Quick-Add-Pending: abbrechen, handleCartUpdatedForQuickAdd übernimmt */
    if (pendingQuickAddProductId) return;

    fetchRecommendations(productId, function (html, hasItems) {
      if (!hasItems) {
        suppressDrawer = false;
        return;
      }
      suppressDrawer = true;
      renderAddedProduct(product);
      renderUpsellItems(html);
      openPopup();
      setTimeout(function () { suppressDrawer = false; }, 1500);
    });
  }

  /* ── Recommendations API ────────────────────────────────────────── */
  function fetchRecommendations(productId, callback) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url =
      root + 'recommendations/products' +
      '?product_id=' + productId +
      '&intent=related' +
      '&limit=4' +
      '&section_id=' + SECTION_ID;

    fetch(url)
      .then(function (resp) {
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        return resp.text();
      })
      .then(function (html) {
        callback(html, html.indexOf('data-fbt-items') !== -1);
      })
      .catch(function (err) {
        console.warn('[FBT] Recommendations-Fetch fehlgeschlagen:', err);
        suppressDrawer = false;
      });
  }

  /* ── Drawer-Unterdrückung ───────────────────────────────────────── */
  function setupDrawerObserver() {
    var quickCart = document.querySelector(QUICK_CART_SELECTOR);
    if (!quickCart) return;

    new MutationObserver(function (mutations) {
      if (!suppressDrawer) return;
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (quickCart.classList.contains(QUICK_CART_ACTIVE)) {
            quickCart.classList.remove(QUICK_CART_ACTIVE);
            document.body.removeAttribute('data-fluorescent-overlay-open');
          }
        }
      });
    }).observe(quickCart, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── Popup-Befüllung: Hinzugefügtes Produkt ─────────────────────── */
  function renderAddedProduct(product) {
    if (!addedProductEl) return;

    var title  = product.title || '';
    var imgSrc = product.featured_image && product.featured_image.url
      ? product.featured_image.url.replace(/\?.*$/, '') + '?width=80'
      : '';

    addedProductEl.innerHTML =
      '<div class="fbt-added__inner">' +
        '<div class="fbt-added__check">' +
          '<svg width="16" height="12" viewBox="0 0 16 12" fill="none" aria-hidden="true">' +
            '<path d="M1 6L6 11L15 1" stroke="#2E7D32" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</div>' +
        '<div class="fbt-added__text">' +
          '<span class="fbt-added__label">Produkt wurde hinzugefügt</span>' +
          (title ? '<span class="fbt-added__title">' + escapeHtml(title) + '</span>' : '') +
        '</div>' +
        (imgSrc
          ? '<img src="' + imgSrc + '" alt="' + escapeHtml(title) + '" class="fbt-added__image" width="56" height="56" loading="eager">'
          : '') +
      '</div>';
  }

  /* ── Popup-Befüllung: Upsell-Items ──────────────────────────────── */
  function renderUpsellItems(sectionHtml) {
    if (!upsellItemsEl) return;

    var tmp = document.createElement('div');
    tmp.innerHTML = sectionHtml;

    var container = tmp.querySelector('[data-fbt-items]');
    if (!container) {
      upsellItemsEl.innerHTML = '';
      return;
    }

    upsellItemsEl.innerHTML = container.innerHTML;
    bindItemButtons();
  }

  /* ── Item-Button-Verdrahtung ────────────────────────────────────── */
  function bindItemButtons() {
    if (!upsellItemsEl) return;

    /* Single-Variante: Hinzufügen-Button */
    upsellItemsEl.querySelectorAll('[data-fbt-add]').forEach(function (btn) {
      btn.addEventListener('click', function () { handleFbtAdd(btn); });
    });

    /* Produkt-Link (Bild/Titel) und „Wählen"-Button werden zentral über den
       Capture-Delegator in bindPopupEvents behandelt (Quick-View im Modal). */
  }

  /* ════════════════════════════════════════════════════════════════
     Fix #1 + #2 — Add/Remove korrekt
     Remove-Button erscheint erst nach erfolgreichem Add.
     Entfernung via /cart/change.js mit dem line_item key aus Response.
     ════════════════════════════════════════════════════════════════ */
  function handleFbtAdd(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains('fbt-rec__btn--added') || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add('fbt-rec__btn--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (resp) { return resp.json(); })
    .then(function (data) {
      if (data.status && data.status >= 400) throw new Error(data.description || 'Add fehlgeschlagen');

      btn.classList.remove('fbt-rec__btn--loading');
      btn.classList.add('fbt-rec__btn--added');
      btn.disabled = false; /* wieder aktivierbar für den Remove-Flow */

      /* Line-item key aus Response (fix #2) */
      var lineKey = data.key || null;
      var resolvedVariantId = data.variant_id || variantId;

      /* Remove-Button erst jetzt einblenden (fix #1) */
      showRemoveButton(btn, lineKey, resolvedVariantId);

      refreshCart();
    })
    .catch(function (err) {
      console.warn('[FBT] Add fehlgeschlagen:', err);
      btn.disabled = false;
      btn.classList.remove('fbt-rec__btn--loading');
    });
  }

  function showRemoveButton(addBtn, lineKey, variantId) {
    /* Remove-Button ist im Liquid als sibling außerhalb des add-Buttons —
       wir erzeugen ihn dynamisch um Nesting-Probleme (button-in-button) zu vermeiden */
    var existingRemove = addBtn.parentNode.querySelector('[data-fbt-remove]');
    if (existingRemove) {
      existingRemove.remove();
    }

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'fbt-rec__btn-remove';
    removeBtn.setAttribute('data-fbt-remove', '');
    removeBtn.setAttribute('aria-label', 'Entfernen');
    removeBtn.innerHTML = '&#215;';
    if (lineKey)    removeBtn.dataset.lineItemKey = lineKey;
    if (variantId)  removeBtn.dataset.variantId   = String(variantId);

    removeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      handleFbtRemove(removeBtn, addBtn);
    });

    addBtn.parentNode.appendChild(removeBtn);
  }

  function handleFbtRemove(removeBtn, addBtn) {
    var lineKey   = removeBtn.dataset.lineItemKey;
    var variantId = removeBtn.dataset.variantId;

    if (!lineKey && !variantId) return;

    removeBtn.disabled = true;
    addBtn.disabled    = true;
    addBtn.classList.add('fbt-rec__btn--loading');

    /* /cart/change.js bevorzugt line_item key (fix #2) */
    var body = lineKey
      ? { id: lineKey, quantity: 0 }
      : { id: parseInt(variantId, 10), quantity: 0 };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function (resp) { return resp.json(); })
    .then(function () {
      addBtn.classList.remove('fbt-rec__btn--added', 'fbt-rec__btn--loading');
      addBtn.disabled = false;
      removeBtn.remove();
      refreshCart();
    })
    .catch(function (err) {
      console.warn('[FBT] Remove fehlgeschlagen:', err);
      addBtn.classList.remove('fbt-rec__btn--loading');
      addBtn.disabled    = false;
      removeBtn.disabled = false;
    });
  }

  /* ════════════════════════════════════════════════════════════════
     Fix #3 — Quick-View IM Popup (inline, kein Redirect)
     Fetcht ?section_id=main (Section Rendering API), injiziert in fbt-quickview-panel,
     blendet Upsell-Liste aus, zeigt Quick-View mit Zurück-Button.
     ════════════════════════════════════════════════════════════════ */
  function openInlineQuickView(productUrl, productId) {
    if (!quickViewPanelEl || !upsellSectionEl) return;
    if (inQuickView) return;
    currentQvProductId = productId || null;

    /* Ladeindikator zeigen */
    quickViewPanelEl.innerHTML =
      '<div class="fbt-qv__loading">' +
        '<div class="fbt-qv__spinner"></div>' +
      '</div>';
    quickViewPanelEl.classList.add('fbt-qv--visible');
    upsellSectionEl.classList.add('fbt-upsell--hidden');
    if (popup) popup.classList.add('fbt-popup--quickview');
    inQuickView = true;

    /* Exakt wie die Theme-eigene Quick-View: ?view=quick-view fetchen (funktioniert
       für ALLE Produkte, auch mit Custom-Template-Suffix wie „optimiert") und das
       [data-is-quick-view]-Element aus der Antwort extrahieren. */
    var cleanUrl = productUrl.split('?')[0];
    var qvUrl = cleanUrl + '?view=quick-view';

    fetch(qvUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (resp) {
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        return resp.text();
      })
      .then(function (html) {
        /* Wie das Theme: aus der quick-view-Seite das [data-is-quick-view]-Element
           ziehen (enthält Galerie, Titel, Preis, Variantenwahl, Add-Button). */
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var qvNode = tmp.querySelector('[data-is-quick-view]');
        var contentHtml = qvNode ? qvNode.outerHTML : html;
        quickViewPanelEl.innerHTML =
          '<div class="fbt-qv__inner">' +
            '<button type="button" class="fbt-qv__back" data-fbt-qv-back>' +
              '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">' +
                '<path d="M11 4L6 9L11 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
              'Zurück' +
            '</button>' +
            '<div class="fbt-qv__scroll">' +
              '<div class="fbt-qv__content">' + contentHtml + '</div>' +
            '</div>' +
            '<div class="fbt-qv__actionbar">' +
              '<button type="button" class="fbt-qv__add" data-fbt-qv-add>' +
                '<span class="fbt-qv__add-text">In den Warenkorb</span>' +
                '<span class="fbt-qv__add-done" aria-hidden="true">' +
                  '<svg width="13" height="10" viewBox="0 0 13 10" fill="none"><path d="M1 5L4.5 8.5L12 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  ' Hinzugefügt' +
                '</span>' +
              '</button>' +
            '</div>' +
          '</div>';

        /* Zurück-Button verdrahten */
        var backBtn = quickViewPanelEl.querySelector('[data-fbt-qv-back]');
        if (backBtn) {
          backBtn.addEventListener('click', closeInlineQuickView);
        }

        /* Theme-interne Quick-View-Skripte aktivieren */
        activateInlineScripts(quickViewPanelEl);

        /* Add-to-Cart in der Quick-View selbst handeln (die Theme-Quick-View-Klasse
           wird hier nicht instanziiert → wir fangen den Submit selbst ab). */
        bindQuickViewAdd();

        /* Theme informieren */
        document.dispatchEvent(new CustomEvent('quickview:loaded', { bubbles: true }));
      })
      .catch(function (err) {
        console.warn('[FBT] Quick-View-Fetch fehlgeschlagen:', err);
        closeInlineQuickView();
      });
  }

  function closeInlineQuickView() {
    if (!quickViewPanelEl || !upsellSectionEl) return;
    quickViewPanelEl.classList.remove('fbt-qv--visible');
    upsellSectionEl.classList.remove('fbt-upsell--hidden');
    if (popup) popup.classList.remove('fbt-popup--quickview');
    inQuickView = false;

    /* Panel erst nach Transition leeren */
    setTimeout(function () {
      if (!inQuickView) quickViewPanelEl.innerHTML = '';
    }, 300);
  }

  /* Add-to-Cart innerhalb der Quick-View selbst übernehmen ─────────────
     Das Theme würde das normalerweise über seine Quick-View-Klasse regeln,
     die wir hier nicht instanziieren. Wir fangen Submit + Button-Klick ab,
     lesen die gewählte Variante aus [name="id"] und adden via /cart/add.js. */
  function bindQuickViewAdd() {
    if (!quickViewPanelEl) return;
    var form    = quickViewPanelEl.querySelector('form[action*="/cart/add"]');
    var barBtn  = quickViewPanelEl.querySelector('[data-fbt-qv-add]');   /* eigene Action-Bar */
    var qvPid   = currentQvProductId;
    if (!barBtn) return;

    var adding = false;

    function doAdd(e) {
      if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
      if (adding) return;

      var idInput = (form && form.querySelector('[name="id"]')) ||
                    quickViewPanelEl.querySelector('[name="id"]');
      var variantId = idInput && idInput.value;
      if (!variantId) {
        /* Variante noch nicht gewählt → kurz Hinweis am Button, Auswahl bleibt sichtbar */
        barBtn.classList.add('fbt-qv__add--hint');
        setTimeout(function () { barBtn.classList.remove('fbt-qv__add--hint'); }, 1200);
        return;
      }

      var qtyInput = form && form.querySelector('[name="quantity"]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      adding = true;
      barBtn.disabled = true;
      barBtn.classList.add('fbt-qv__add--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          refreshCart();
          var lineKey = data && data.key;
          var vId     = (data && data.variant_id) || variantId;
          /* passendes Upsell-Item als „im Warenkorb" markieren */
          markUpsellAdded(qvPid, lineKey, vId);
          barBtn.classList.remove('fbt-qv__add--loading');
          barBtn.classList.add('fbt-qv__add--done');
          /* kurz Erfolg zeigen, dann zurück zur Upsell-Liste */
          setTimeout(closeInlineQuickView, 850);
        })
        .catch(function (err) {
          console.warn('[FBT] Quick-View-Add fehlgeschlagen:', err);
          adding = false;
          barBtn.disabled = false;
          barBtn.classList.remove('fbt-qv__add--loading');
        });
    }

    barBtn.addEventListener('click', doAdd);
    if (form) form.addEventListener('submit', doAdd, true);  /* Enter im Formular */
  }

  /* Upsell-Item nach Quick-View-Add visuell auf „im Warenkorb" setzen */
  function markUpsellAdded(productId, lineKey, variantId) {
    if (!upsellItemsEl || !productId) return;
    var item = upsellItemsEl.querySelector('[data-fbt-item][data-product-id="' + productId + '"]');
    if (!item) return;
    var btn = item.querySelector('[data-fbt-add], [data-fbt-quickview]');
    if (!btn) return;
    btn.classList.add('fbt-rec__btn--added');
    btn.disabled = true;
    if (!btn.querySelector('.fbt-rec__btn-text-added')) {
      btn.innerHTML =
        '<span class="fbt-rec__btn-text-add">Hinzufügen</span>' +
        '<span class="fbt-rec__btn-text-added" aria-hidden="true">' +
          '<svg width="13" height="10" viewBox="0 0 13 10" fill="none"><path d="M1 5L4.5 8.5L12 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          ' Hinzugefügt' +
        '</span>';
    }
    showRemoveButton(btn, lineKey, variantId);
  }

  /* Inline-Scripts aus geferchtem HTML ausführen */
  function activateInlineScripts(container) {
    var scripts = container.querySelectorAll('script');
    scripts.forEach(function (oldScript) {
      /* Externe Bundles (theme.js, swiper etc.) NIE neu laden — die laufen schon
         auf der Seite. Neu-Ausführen re-initialisiert den Theme-Router → Redirect. */
      if (oldScript.src) return;
      /* Daten-Blöcke (application/json, ld+json) NICHT ausführen — die liest das
         Theme als Daten (Produkt-/Variantendaten). Als JS gäbe das Syntaxfehler. */
      var type = oldScript.getAttribute('type');
      if (type && !/^(text\/javascript|module|application\/javascript)$/i.test(type)) return;
      var newScript = document.createElement('script');
      if (type) newScript.type = type;
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  /* ── Cart aktualisieren ─────────────────────────────────────────── */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (resp) { return resp.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
      })
      .catch(function () {});
  }

  /* ── Popup öffnen / schliessen ──────────────────────────────────── */
  function openPopup() {
    if (!popup) return;
    inQuickView = false;

    /* Quick-View-Panel zurücksetzen */
    if (quickViewPanelEl) {
      quickViewPanelEl.classList.remove('fbt-qv--visible');
      quickViewPanelEl.innerHTML = '';
    }
    if (upsellSectionEl) upsellSectionEl.classList.remove('fbt-upsell--hidden');

    popup.hidden = false;
    popup.removeAttribute('aria-hidden');
    document.body.classList.add('fbt-popup-open');
    popupOpen = true;

    requestAnimationFrame(function () {
      var first = popup.querySelector('button, [href], input, select, textarea');
      if (first) first.focus();
    });
  }

  function closePopup() {
    if (!popup) return;
    inQuickView = false;
    /* Fokus aus dem Popup nehmen, bevor aria-hidden gesetzt wird (a11y-Warnung) */
    if (document.activeElement && popup.contains(document.activeElement)) {
      try { document.activeElement.blur(); } catch (e) {}
    }
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    popup.classList.remove('fbt-popup--quickview');
    document.body.classList.remove('fbt-popup-open');
    popupOpen = false;
    suppressDrawer = false;
  }

  /* ── Popup-Event-Bindungen ──────────────────────────────────────── */
  function bindPopupEvents() {
    if (!popup) return;

    /* Produkt-Klick (Bild/Titel) + „Wählen" → Quick-View IM Modal, NIE zur Produktseite.
       Capture-Phase + stopImmediatePropagation schlägt einen evtl. Theme-Link-Interceptor,
       der sonst vor unserem preventDefault navigiert. Delegiert = überlebt Re-Renders. */
    popup.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-fbt-product-link], [data-fbt-quickview]');
      if (!trigger || !popup.contains(trigger)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var url = trigger.getAttribute('href') || (trigger.dataset && trigger.dataset.productUrl);
      var item = trigger.closest('[data-fbt-item]');
      var pid = (item && item.dataset.productId) || (trigger.dataset && trigger.dataset.productId) || null;
      if (url) openInlineQuickView(url, pid);
    }, true);

    popup.addEventListener('click', function (e) {
      /* Schliessen */
      if (e.target.closest('[data-fbt-close]')) { closePopup(); return; }
      /* Zum Warenkorb */
      if (e.target.closest('[data-fbt-open-cart]')) { closePopup(); openQuickCart(); return; }
      /* Quick-View zurück */
      if (e.target.closest('[data-fbt-qv-back]')) { closeInlineQuickView(); return; }
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && popupOpen) {
        if (inQuickView) closeInlineQuickView();
        else closePopup();
      }
    });
  }

  function openQuickCart() {
    /* v4 (2026-07-12): zentrale robuste Drawer-Öffnung aus custom.js (Sticky-Klon-sicher) */
    if (window.hkiOpenCartDrawer && window.hkiOpenCartDrawer()) return;
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  /* ── Hilfsfunktionen ────────────────────────────────────────────── */
  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  /* ── DOM Ready ──────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
